import { render, staticRenderFns } from "./StudentEmailModal.vue?vue&type=template&id=04c43dbc&scoped=true&"
import script from "./StudentEmailModal.vue?vue&type=script&lang=js&"
export * from "./StudentEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./StudentEmailModal.vue?vue&type=style&index=0&id=04c43dbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c43dbc",
  null
  
)

export default component.exports